module.exports = __webpack_public_path__ + "static/mighty_home-6cba8a84e398c69263050ae82aa44dce.png";